/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateFolderDto } from '../../models/create-folder-dto';
import { Folder } from '../../models/folder';

export interface FolderControllerCreateFolderAndAddToFolder$Params {
  folderId: string;
      body: CreateFolderDto
}

export function folderControllerCreateFolderAndAddToFolder(http: HttpClient, rootUrl: string, params: FolderControllerCreateFolderAndAddToFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<Folder>> {
  const rb = new RequestBuilder(rootUrl, folderControllerCreateFolderAndAddToFolder.PATH, 'post');
  if (params) {
    rb.path('folderId', params.folderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Folder>;
    })
  );
}

folderControllerCreateFolderAndAddToFolder.PATH = '/folder/{folderId}';
